class B2BUserModel {
    constructor(b2bUsers) {
        this.B2BbUsers = [];
        if (Array.isArray(b2bUsers)) {
            this.B2BbUsers = b2bUsers?.map(agent =>
                agent?.Users?.map(user => ({
                    AgentName: agent?.Name || "N/A",
                    DisplayName: user?.DisplayName || "N/A",
                    FirstName: user?.FirstName || "N/A",
                    LastName: user?.LastName || "N/A",
                    Email: user?.Email || "N/A",
                    Phone: user?.PhoneNumber || "N/A",
                })) || []
            ).flat();
        }
    }
}

export default B2BUserModel;
